import { render, staticRenderFns } from "./gHandleNumber.vue?vue&type=template&id=159ce028&scoped=true"
import script from "./gHandleNumber.vue?vue&type=script&lang=js"
export * from "./gHandleNumber.vue?vue&type=script&lang=js"
import style0 from "./gHandleNumber.vue?vue&type=style&index=0&id=159ce028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ce028",
  null
  
)

export default component.exports